import gql from 'graphql-tag'

const updateAssenza = gql`
  mutation updateAssenza($assenza: UpdateAssenza!, $id: Int!) {
    updateAssenza(assenza: $assenza, id: $id) {
      id
      utenteId
      utente {
        id
        nome
      }
      daDataOra
      aDataOra
      descrizione
      flagOccupato
    }
  }
`

export default updateAssenza


// WEBPACK FOOTER //
// ./src/graphql/mutations/updateAssenza.js